<template>
  <v-app>
    <Authentication
      :register="null"
      :resetPassword="null"
      :cancel="'Cancel'"
      :success="true"
      :operationField="'appRegister'"
      :transactionField="'registerTran'"
      :registerField="null"
      :resetPasswordField="null"
      :maxWidth="null"
      @transaction-process="transactionProcess"
      @close-dialog="closeDialog"
    />
  </v-app>
</template>

<script>
import { environment } from "./../../../environment/environment.js";
import Authentication from './Authentication';

export default {
  name: "Register",
  props: [],
  data() {
    return {
      environment: environment,
      registerSuccess: false,
      registerData: {}
    };
  },
  components: {
    Authentication
  },
  methods: {
    transactionProcess(data) {
      this.registerSuccess = data.success;
      if (data.success == true) {
        this.registerData = data.data;
      }
    },

    closeDialog(data) {
      if (this.registerSuccess) {
        const authentication = data.generalExApplicationEx.authentication;
        const userName = this.registerData[authentication.userId];
        this.goToConfirm(data.applicationName, userName);
      }
    },

  },
  created() {
  },
};
</script>

<style>
</style>